import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { LocalStorageService } from '@/services/local-storage.service';
import { AUTH_STORAGE_KEYS } from '@/auth/values/auth.values';
import { _MEETINGS_STORE } from '@/meetings/values/meetings.values';

const pageSizes = {
  letter: {
    w: 816,
    h: 1054,
  },
  legal: {
    w: 816,
    h: 1346,
  },
  a4: {
    w: 794,
    h: 1123,
  },
}; // Letter@

const TIME_TO_SHOW_MESSAGES = 2000;

@Component({name: 'ed-edupad'})
export default class EdEdupad extends Vue {
  protected readonly socketIoPath = '/pad/socket.io'; 
  protected readonly token = LocalStorageService.getItem(AUTH_STORAGE_KEYS.ED_JWT);
  protected readonly dynamicId = Math.random().toString(36).slice(-6);

  get username():string {
    if(this.$store.state.AuthStore.user.userId) {
      return this.$store.state.AuthStore.user.userId;
    }
    return '';
  }

  get edupadUrl(): string {
    return this.$store.state.AuthStore.edupadUrl;
  }

  get socketIOOptions(){
    return {
      // reconnection: true,
      // reconnectionDelay: 100,
      // timeout: 300000,
      transports: ['websocket'],
      path: this.socketIoPath,
      auth: {token: this.token}
    }
  }

  get pageSizes(){
    return pageSizes;
  }

  get messageTime(){
    return TIME_TO_SHOW_MESSAGES;
  }
}
